import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Fonts } from "@snapchat/snap-design-system";

export const visibilityOptionStyle = css`
    cursor: pointer;

    align-items: flex-start;

    width: 100%;
    height: 56px;
    padding: 8px 16px;

    border-radius: 6px;

    :hover,
    :focus {
        background: ${Colors.Gray.V50};
    }
`;

// https://github.sc-corp.net/Snapchat/snap-design-system/blob/c12dfccb6f59dd79a933f18060419629fdd95ddb/packages/snap-design-system/src/components/Button/BaseButton.scss#L76
export const visibilityOptionStyleDisabled = css`
    cursor: not-allowed;
    background: ${Colors.Gray.V150}
        repeating-linear-gradient(
            45deg,
            ${Colors.Gray.V200},
            ${Colors.Gray.V200} 1px,
            ${Colors.Gray.V150} 1px,
            ${Colors.Gray.V150} 5px
        );
    box-shadow: 0 0 0 1px ${Colors.Gray.V200};

    :hover,
    :focus {
        background: ${Colors.Gray.V150}
            repeating-linear-gradient(
                45deg,
                ${Colors.Gray.V200},
                ${Colors.Gray.V200} 1px,
                ${Colors.Gray.V150} 1px,
                ${Colors.Gray.V150} 5px
            );
        box-shadow: 0 0 0 1px ${Colors.Gray.V200};
    }
`;

export const VisibilityOptionContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    padding-left: 8px;

    ${Fonts.Paragraph.P300};
    color: ${Colors.Gray.V300};
`;

export const VisibilityLabel = styled.span`
    align-self: flex-start;

    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${Colors.Black.V200};
`;

export const SpinnerContainer = styled.div`
    align-self: center;
    margin-right: 16px;
`;
